import { Roles } from '@/enums'
import { prop, propEq } from 'ramda'

export const isAdmin = propEq(Roles.admin, 'role')

export const isVerified = prop('emailVerified')
